// 📁 src/pages/PostLogin.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PostLogin() {
  const { user, checkingUser, profileComplete } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (checkingUser) return;

    if (!user) {
      navigate('/login');
    } else if (!profileComplete) {
      navigate('/onboarding');
    } else {
      navigate('/dashboard');
    }
  }, [checkingUser, user, profileComplete, navigate]); // <- ⚠️ IMPORTANTE: adicione todos no array

  return (
    <div className="loading-container">
      <p>Verificando login...</p>
    </div>
  );
}
